// extracted by mini-css-extract-plugin
export default {"message":"ktv9F"};